import {getSchemaForColumn} from 'notebook/sample-propagation/util/getSchemaForColumn';
import {
  ColumnDefinition,
  ContainersColumnDefinition,
} from 'notebook/structured-tables/columns/ColumnDefinitions';

/**
 * Tools to extract the schema ID from a table column
 */

export function getSchemaIdForEntityColumn(columnDefinition: ColumnDefinition): string | null {
  return getSchemaForColumn(columnDefinition)?.id ?? null;
}

export function getSchemaIdForContainersColumn(columnDefinition: ContainersColumnDefinition): string | null {
  return getSchemaForColumn(columnDefinition)?.id ?? null;
}
